import React from "react";

type ShowProps = {
 ifcond: boolean;
 children: React.ReactNode;
};

const Show: React.FC<ShowProps> = ({ ifcond, children }) => {
 return ifcond ? <>{children}</> : null;
};

export default Show;
